import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTextareaAutosize, TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup,  ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GeaMesCognitoAuthService } from '@gea-mes/cognito';
import { Observable, pluck, Subscription } from 'rxjs';
import { EamService } from 'src/app/services/eam.service';
import { FaultData } from '../problem-list.component';
import { EamWorkRequestListComponent } from '../eam-work-request-list/eam-work-request-list.component';
import { MatCardModule } from '@angular/material/card';

export interface EAMDialogData {
  problemData: FaultData,
  id: number,
  site:string,
  eamAsset: string
}

@Component({
  selector: 'app-eam-work-request',
  imports: [CommonModule, MatFormFieldModule, ReactiveFormsModule, MatButtonModule, MatDialogModule, MatInputModule, TextFieldModule, CdkTextareaAutosize, ScrollingModule, MatSelectModule, MatCardModule],
  templateUrl: './eam-work-request.component.html',
  styleUrl: './eam-work-request.component.scss'
})
export class EamWorkRequestComponent {

  private svcEAM = inject(EamService);
  private breakpointObserver = inject(BreakpointObserver);
  private svcCognito = inject(GeaMesCognitoAuthService);
  private snackBar = inject(MatSnackBar);

  eamServiceSubscription: Subscription;
  childAsset: string = '';
  childAssetOptions: ChildAssetOption[] = [];
  workPriorityOptions: PriorityOption[] = [
      {value: '04-STAN-5-14D', viewValue: '5-14 Days (04-STAN-5-14D)'},
      {value: '05-STAN-15-30D', viewValue: '15-30 Days (05-STAN-15-30D)'},
      {value: '06-STAN-31-90D', viewValue: '31-90 Days (06-STAN-31-90)'},
      {value: '09-NON-OP', viewValue: 'No Production Impact (09-NON-OP)'}
    ];

  isLoading:boolean = true;
  workRequestFormGroup!: FormGroup;

  userID: string = 'UNKNOWN';

  eAMCharacterCount: number = 186;

  problemData:FaultData;
  viewOnly:boolean = true;

  isTablet$: Observable<BreakpointState> = this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall])
  isScreen$: Observable<BreakpointState> = this.breakpointObserver.observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])

  constructor(
    public dialogRef: MatDialogRef<EamWorkRequestComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: EAMDialogData,
  ) {

    this.userID = this.svcCognito.getUserAttribute('sso');
    this.problemData = data.problemData;

    if (this.problemData.AssetNumber == '') {
      this.viewOnly = false;
    } else {
      this.viewOnly = true;
    }

    this.workRequestFormGroup = this.fb.group({
      description: new FormControl<string>({value:'', disabled: false}, Validators.required),
      childAsset: new FormControl<string>({value:'', disabled: false}, Validators.required),
      workPriority: new FormControl<string>({value:'', disabled: false}, Validators.required)
    });

    this.eamServiceSubscription = this.svcEAM.getEAMAssetList(this.data.site, this.data.eamAsset).pipe(
      pluck('Body')
    ).subscribe((assetListRestRaw: any[]) =>{
      this.childAssetOptions = assetListRestRaw;
      this.childAsset = '';

      this.isLoading = false;
    });
  }

  createWorkRequest() {
    let description: string = `REQUEST-${this.userID} | ${this.workRequestFormGroup.get('description')?.value}`;
    let childAsset: string = this.workRequestFormGroup.get('childAsset')?.value;
    let workPriority: string = this.workRequestFormGroup.get('workPriority')?.value;

    this.svcEAM.createWorkRequest(this.data.id, childAsset, description, workPriority, this.data.site).subscribe(
        (result) =>{
          if (result['Body'] == "Work Order Already Exists"){
            let message = "Work Order Already Exists"
            let action = "Error"
            this.snackBar.open(message, action, {
              duration: 2000,
            });
          }

          this.dialogRef.close({update: true });
        }
    )
  }

  viewWorkRequest() {
    const dialogRef = this.dialog.open(EamWorkRequestListComponent, {
      width: '575px',
      maxHeight: '700px',
      data: {
              eamAsset: this.data.eamAsset
            }
    });
  }

  onNoClick() {
    this.dialogRef.close({update: false});
  }
}

export interface PriorityOption {
  value: string
  viewValue: string
}

export interface ChildAssetOption {
  CHILD_ASSET: string;
  INSTANCE_DESCRIPTION: string;
  MAINTAINABLE_FLAG: string;
} 